import { PriceNext, QuoteStatus } from 'components/shared/PriceNext';
import { FC, PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import { connectInitialized, InitializedState } from './Initialized.status.connect';

export const Component: FC<PropsWithChildren<InitializedState>> = ({ workspaceType, solvingMode }) => {
  return (
    <PriceNext
      className="text-secondary border"
      solveMode={
        <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
      }
      quoteStatus={<QuoteStatus icon="filter_tilt_shift" description="sidePanel.quoteStatus.notReady" />}
    />
  );
};

export const InitializedComponent = connectInitialized(Component);

Component.displayName = 'Initialized';
